<template>
  <div v-if="product && productPrice">
    <div :class="brandClasses.headingWrapper">
      <template v-if="product.eyebrow">
        <vf-toggletip v-if="product.eyebrow.details">
          <template #trigger>
            <span class="flex items-center gap-1">
              <p v-bind="eyebrowStyle" class="line-clamp-1 eyebrow">
                {{ product.eyebrow.label }}
              </p>
              <vf-icon name="info" />
            </span>
          </template>
          {{ product.eyebrow.details }}
        </vf-toggletip>
        <p v-else-if="product.eyebrow.label" v-bind="eyebrowStyle" class="line-clamp-1 eyebrow">
          {{ product.eyebrow.label }}
        </p>
      </template>
      <h1 v-if="!isElevated" :class="brandClasses.headingProductName" data-test-id="product-name">
        {{ product.name }}
      </h1>
      <p v-if="product.promoExclusionsMessage" :class="brandClasses.headingExclusions">
        {{ product.promoExclusionsMessage }}
      </p>
      <product-reviews-summary v-if="!isElevated" :reviews-data="reviewsData" />
    </div>
    <product-pricing
      :class="brandClasses.headingProductPricing"
      :currency="product.currency"
      :price="productPrice"
      :show-discount-percentage="$feature.showDiscountPercentageOnCatalog"
      :show-original-price-for-omnibus="$feature.showOmnibusBadgeOnQuickshopAndPDP"
    />
  </div>
</template>

<script lang="ts" setup>
const { eyebrowStyle, product, productPrice, reviewsData } = usePdp()
const { brandClasses } = useAppConfig().pages.pdp

const isElevated = computed(() => product.value?.elevatedPDPDetails?.enable)
</script>
